export default __webpack_public_path__ + "static/media/exclamation.b22d130e.svg";